/**
 * Calculate required capital for a strategy based on its type and parameters.
 * Shared between CapitalRequirements, CollapsibleAccountInfo, and ValidationModal.
 *
 * @param {string} strategyType - Strategy type key (grid, mean_reversion, etc.)
 * @param {object} parameters - Strategy parameters object
 * @returns {number} Required capital in dollars
 */
export function calculateRequiredCapital(strategyType, parameters) {
  if (!parameters) return 0;

  switch (strategyType) {
    case 'grid': {
      const {
        gridLevels = 10,
        orderSize = 10,
        upperBound = 180,
        lowerBound = 170,
        sizingMode,
        martingaleMultiplier = 2,
      } = parameters;
      const avgPrice = (upperBound + lowerBound) / 2;
      const buyLevels = Math.ceil(gridLevels / 2);

      if (sizingMode === 'fixed_investment') {
        return buyLevels * orderSize;
      }
      if (sizingMode === 'martingale') {
        const m = martingaleMultiplier;
        if (m <= 1) return buyLevels * orderSize * avgPrice;
        return (orderSize * avgPrice * (Math.pow(m, buyLevels) - 1)) / (m - 1);
      }
      // fixed_shares / fixed_quantity / default
      return buyLevels * orderSize * avgPrice;
    }

    case 'mean_reversion':
    case 'momentum':
    case 'arbitrage': {
      const { positionSize = 1000 } = parameters;
      return positionSize;
    }

    case 'market_making': {
      const { maxPosition = 100 } = parameters;
      const estimatedPrice = 200;
      return maxPosition * estimatedPrice;
    }

    default:
      return 0;
  }
}
